<template>
  <div>
    <v-form
        ref="form"
        v-model="valid"
        lazy-validation
        @submit.prevent="buscar()"
        :disabled="!isNew"
    >
      <v-radio-group
          v-model="opcion"
          row
          @change="elejirOpcion()"
      >
        <table style="width: 100%">
          <tr>
            <td>
              <v-radio
                  label="Cuenta"
                  value="Cuenta"
              />
            </td>
            <td>
              <v-radio
                  label="G - Trámites"
                  value="Tramite"
              />
            </td>
            <td>
              <v-radio
                  label="Créditos"
                  value="Credito"
              />
            </td>
            <td>
              <v-radio
                  label="Cisterna"
                  value="Cisterna"
              />
            </td>
            <td>
              <v-radio
                  label="Sancion"
                  value="Sancion"
              />
            </td>
            <td>
              <v-radio
                  label="Pasivo"
                  value="Pasivo"
              />
            </td>
            <td>
              <v-radio
                  label="Laboratorio"
                  value="Laboratorio"
              />
            </td>
            <td>
              <v-radio
                  label="Corte"
                  value="Corte"
              />
            </td>
            <td>
              <v-radio
                  label="Cambio Nombre"
                  value="CambioNombre"
              />
            </td>
          </tr>
        </table>
      </v-radio-group>
      <v-col cols="12" md="6" offset-md="3" style="margin-top: -20px">
<!--        @keypress="patterns.onlyNumber($event)"-->
        <v-text-field
            v-model="txtCodigo"
            label="Ingrese código"
            ref="codigo"
            @keyup.enter="buscar()"
            dense
            autofocus
            outlined
            maxlength="9"
            clearable
            :rules="[v => !!v || 'Código es requerido',
                   v => v?.toString().length >= 1 && v?.toString().length <= 9 || 'Código debe tener entre 1 y 9 dígitos']"
            :loading="loading"
            :disabled="loading"
        />
      </v-col>
    </v-form>
    <v-divider style="margin-top: -20px"/>
    <v-row class="pl-2 pt-1 pb-1 font-weight-light"
           v-if="cliente && cliente.cuenta && cliente.cuenta !== '' && cliente.cuenta !== null">
      <v-col cols="12" md="4">Cuenta: {{ cliente.cuenta }}</v-col>
      <v-col cols="12" md="4">Catastro: {{ cliente.catastro }}</v-col>
      <v-col cols="12" md="4">Medidor: {{ cliente.medidor }}</v-col>
    </v-row>

    <v-divider/>

    <template v-if="!isNew">
      <v-form ref="formClient" v-model="validClient" lazy-validation>
        <v-card-text>
          <v-row>
            <v-col cols="12" md="4">
              <v-text-field
                  v-model="cliente.ci"
                  label="Ci/Nit *"
                  dense
                  :rules="[v => !!v || 'Ci o Nit es requerida']"
                  @keypress="patterns.onlyNumber($event)"
                  @keyup="patterns.toUpper($event)"
                  @keyup.enter="getCliente(cliente.ci)"
                  @focusout="getCliente(cliente.ci)"
                  :disabled="opcion !== 'Cuenta' && opcion !== 'Sancion'"
              />
            </v-col>
            <v-col cols="12" md="8">
              <v-text-field
                  v-model="cliente.nombre"
                  label="Razón social *"
                  dense
                  @keyup="patterns.toUpper($event)"
                  :rules="[v => !!v || 'Razón social es requerida']"
                  :disabled="opcion !== 'Cuenta'"
              />
            </v-col>
            <v-col cols="12" md="8" style="margin-top: -20px">
              <v-text-field
                  v-model="cliente.direccion"
                  label="Dirección *"
                  dense
                  @keyup="patterns.toUpper($event)"
                  :rules="[v => !!v || 'Dirección es requerida']"
                  :disabled="opcion !== 'Cuenta'"
              />
            </v-col>
            <v-col cols="12" md="4" style="margin-top: -20px">
              <v-text-field
                  v-model="cliente.email"
                  label="Email"
                  dense
                  :rules="[v => !v || /.+@.+\..+/.test(v) || 'Formato de email inválido']"
                  :disabled="cliente.tieneEmail"
              />
            </v-col>
          </v-row>
        </v-card-text>

        <v-simple-table class="simple-table" dense v-if="!cabecera.cuota_inicla_cancelado">
          <thead>
          <tr>
            <th>#</th>
            <th>Código</th>
            <th>Concepto</th>
            <th v-if="opcion === 'Cisterna'" class="text-right">Cantidad (m3)</th>
            <th class="text-right">Valor (Bs)</th>
            <th></th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item, index) in detalles" :key="index">
            <td>{{ index + 1 }}</td>
            <td>{{ item.codigo }}</td>
            <td>{{ item.concepto }}</td>
            <td v-if="opcion === 'Cisterna'" class="text-right">{{ item.cantidad | round }}</td>
            <td class="text-right font-weight-bold">
              <input v-if="opcion === 'Cuenta' && item.codigo !== '2216'" type="text" v-model="item.valor"
                     @keypress="patterns.onlyDecimal($event)" style="max-width: 80px; text-align: right">
              <span v-else>{{ item.valor | round }}</span>
            </td>
            <td class="text-right">
              <v-btn
                  v-if="opcion === 'Cuenta' && item.codigo !== '2216'"
                  icon
                  color="error"
                  small
                  @click="eliminarItem(index)"
              >
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </td>
          </tr>
          <tr v-if="opcion === 'Cuenta'">
            <td colspan="3">
              <v-autocomplete
                  v-model="cuenta"
                  :items="cuentas"
                  item-text="info"
                  item-value="codigo"
                  label="Lista de cuentas"
                  dense
                  clearable
                  class="mt-3"
                  return-object
                  @keyup.enter="agregarItem()"
              />
            </td>
            <td colspan="2">
              <v-btn
                  small
                  outlined
                  @click="agregarItem()"
              >
                + Agregar cuenta
              </v-btn>
            </td>
          </tr>
          </tbody>
        </v-simple-table>
        <template v-if="cabecera.cuota_inicla_cancelado">
        <h3 align="center">Cuotas</h3>
          <v-simple-table dense>
            <template v-slot:default>
              <thead>
              <tr>
                <th>#</th>
                <th>Amortizacion</th>
                <th>Interes</th>
                <th>Formulario</th>
                <th class="text-right">Monto (Bs)</th>
                <th class="text-right"></th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(item, index) in cuotas" :key="index">
                <td>{{ item.numero_cuota }}</td>
                <td>{{ item.amortizacion }}</td>
                <td>{{ item.interes_pagado | round }}</td>
                <td>{{ item.formulario | round }}</td>
                <td class="text-right font-weight-bold">{{ parseFloat(item.amortizacion) + parseFloat(item.formulario) | round }}</td>
                <td @click="seleccionarCuota(item)" class="text-right" style="cursor: pointer; width: 50px">
                  <v-icon v-if="item.selected" color="primary">mdi-checkbox-marked</v-icon>
                  <v-icon v-else color="primary">mdi-checkbox-blank-outline</v-icon>
                </td>
              </tr>
              <tr>
                <td colspan="3" class="text-right font-weight-light">
                  TOTAL CUOTAS
                </td>
                <td class="text-right font-weight-light">{{
                    totalCuotas | round2
                  }}
                </td>
                <td style="width: 65px"></td>
              </tr>
              </tbody>
            </template>
          </v-simple-table>
        </template>

        <v-row class="mt-5">
          <v-col cols="12" md="12">
            <v-text-field
                v-if="opcion !== 'Cisterna'"
                v-model="cabecera.glosa"
                label="Glosa *"
                style="margin-top: -10px"
                dense
                autofocus
                :rules="[v => !!v || 'Glosa es requerida']"
                @keyup.enter="$refs.montoRec.focus()"
                :disabled="true"
            />
          </v-col>

          <v-col cols="12" md="3">
            <v-text-field
                v-model="montoRecibido"
                label="Monto recibido (Bs)"
                outlined
                dense
                class="mt-2"
                ref="montoRec"
                @keypress="patterns.onlyDecimal($event)"
                @keyup.enter="guardar()"
            />
          </v-col>
          <v-col cols="12" md="3">
            <div class="mt-4">
              Cambio (Bs):
              <span v-if="cambio > 0">{{ cambio | round }}</span>
            </div>
          </v-col>
          <v-col cols="12" md="6">
            <v-alert
                dense
                outlined
                text
                color="success"
                class="text-right font-weight-bold text-sm-h6"
            >
              TOTAL A PAGAR (Bs): <strong>{{ total | round }}</strong>
            </v-alert>
          </v-col>
        </v-row>
        <v-footer class="mb-3">
          <v-spacer/>
          <v-btn
              color="primary"
              @click="guardar()"
              :loading="loading"
          >
            Guardar pago
          </v-btn>
          <v-btn
              class="ml-2"
              outlined
              color="secundary"
              @click="cancelar()"
          >
            Nuevo
          </v-btn>
        </v-footer>
      </v-form>
    </template>
    <div id="myElement"></div>
  </div>
</template>

<script lang="ts">
import {Component, Vue} from "vue-property-decorator";
import {Pattern} from "@/addons/Pattern";
import {Alert} from "@/addons/Alert";
import {RecaudacionService} from "@/services/RecaudacionService";
import {recaudacionStore} from "@/store/recaudacionStore";
import {FacturaOtroIngreso} from "@/models/FacturaOtroIngreso";
import {Cuenta} from "@/models/Cuenta";
import {PrintOtroIngreso} from "@/addons/PrintOtroIngreso";

@Component({
  name: "RecaudacionOtroIngreso",
})

export default class RecaudacionOtroIngreso extends Vue {
  private patterns = Pattern;
  private recaudacionService = RecaudacionService.getInstance();
  private recaudacionStore = recaudacionStore();

  private opcion: any = "Cuenta";
  private txtCodigo = null;
  private montoRecibido = null;
  private cuenta: any = null;
  valid = true;
  validClient = true;
  $refs!: {
    form: HTMLFormElement,
    codigo: HTMLInputElement,
    montoRec: HTMLInputElement,
    formClient: HTMLFormElement
  };

  private headers = [
    {text: "Nro. Cuota", value: "numero_cuota", sortable: false},
    {text: "Cuota", value: "amortizacion", sortable: false},
    {text: "Formularo (Bs)", value: "precio_actualizado.formulario", align: 'end', sortable: false},
    {text: "", value: "seleccion", sortable: false},
  ];

  mounted() {
    this.$refs.codigo.focus();
    this.recaudacionService.getCuentas()
  }
  seleccionarFacturas(cuota: any) {
    this.cuotas.reduce((acc, item) => {
      if (parseInt(item.numero_cuota) <= parseInt(cuota.numero_cuota)) {
        item.selected = true;
        return acc + 1;
      } else {
        item.selected = false;
        return acc + 1;
      }
    }, 0);

    this.detalles.forEach((item) => {
        item.valor = this.totalCuotas;
    })

    //completar selecciones segun el minimo de factuas que puede cobrar
    //this.completarSeleccionesPermitidad();

  }

  seleccionarCuota(cuota: any) {
    console.log(cuota)
    if (cuota.selected){
    this.cuotas.reduce((acc, item) => {
      if (parseInt(item.numero_cuota) <= parseInt(cuota.numero_cuota)) {
        item.selected = true;
        return acc + 1;
      } else {
        item.selected = false;
        return acc + 1;
      }
    }, 0);
    this.detalles.forEach((item) => {
      if (item.es_cuota) {
        item.valor = this.totalCuotas;
      }
    })
    }
  }

  get isNew(): boolean {
    return this.recaudacionStore.isNewOtroIngreso;
  }

  get cliente() {
    return this.recaudacionStore.facturaOtroIngreso.cliente;
  }

  get cabecera() {
    return this.recaudacionStore.facturaOtroIngreso.cabecera;
  }

  get detalles() {
    return this.recaudacionStore.facturaOtroIngreso.detalles;
  }
  get cuotas(){
    return this.recaudacionStore.facturaOtroIngreso.cuotas;
  }

  get loading() {
    return this.recaudacionStore.loading;
  }

  get cuentas(): Cuenta[] {
    return this.recaudacionStore.cuentas;
  }

  round(value: number) {
    return Math.round(value * 100) / 100;
  }

  buscar() {
    if (this.opcion !== "Cuenta" && !this.$refs.form.validate()) {
      return;
    }

    const data = {
      tipo: this.opcion,
      codigo: this.txtCodigo
    }

    this.recaudacionService.getOtroIngreso(data);
  }

  cancelar() {
    this.recaudacionStore.isNewOtroIngreso = true;
    this.recaudacionStore.facturaOtroIngreso = new FacturaOtroIngreso();
    this.txtCodigo = null;
    this.montoRecibido = null;

    this.elejirOpcion();
  }

  get total(): number {
    return this.detalles.reduce((acc, item) => {
      return parseFloat(acc) + parseFloat(item.valor);
    }, 0)
  }

  // get totalCuotas(): number {
  //   return this.totalConsumoAgua + this.totalOtrosIngresos;
  // }
  get totalTotal(): number {
    return this.totalCuotas;
  }

  get totalCuotas(): number {
    let sum = 0;
    this.cuotas.forEach((item) => {
      if (item.selected){
        sum += parseFloat(item.amortizacion);
      }
    })
    return sum;
  }

  get cambio(): number {
    return (this.montoRecibido ?? 0) - this.total;
  }

  get formatGlosa(): string {
    return this.recaudacionStore.facturaOtroIngreso.detalles?.reduce((acc: string, item) => {
      if (item.glosa !== undefined)
        return acc + item.glosa + ", ";
      else
        return acc
    }, "")
  }

  elejirOpcion() {
    this.txtCodigo = null;
    this.$refs.codigo.focus();
  }
  guardar() {
    if (!this.$refs.formClient.validate()) {
      return;
    }
    let find = this.detalles.find(item => item.valor === "0")
    if (find !== undefined) {
      Alert.error("El monto no puede ser 0");
      return;
    }
    Alert.confirm(`Resumen: <br>
                    Trámite: ${this.txtCodigo} <br>
                    Total (Bs):  ${this.round(this.total)}`
    ).then(res => {
      if (res.isConfirmed) {
        this.recaudacionStore.facturaOtroIngreso.cabecera.total = this.total;
        const data = this.recaudacionStore.facturaOtroIngreso;
        this.cancelar();
        this.recaudacionService.pagarOtroIngreso(data).then((res) => {
          if (res) {
            let fac = this.recaudacionStore.facturaPrintOtroIngreso;
            this.imprimir(fac);
          }
        });
      }
    })
  }

  private imprimir(fac: any) {
    const print = new PrintOtroIngreso();
    print.imprimir(fac);
  }

  agregarItem() {
    if (this.cuenta === null) {
      Alert.error("Elija una cuenta para agregar a la lista");
      return;
    }
    if (this.existeCuentaEnDetalle(this.cuenta.codigo)) {
      Alert.error("Ya has agregado este concepto con anterioridad. Elija otro");
      return;
    }

    this.recaudacionStore.facturaOtroIngreso.detalles.push(this.cuenta);
    this.cabecera.glosa = this.formatGlosa;
    this.cuenta = null;
  }

  existeCuentaEnDetalle(codigo: number): boolean {
    return this.detalles.find(item => item.codigo === codigo);
  }

  eliminarItem(index: any) {
    this.recaudacionStore.facturaOtroIngreso.detalles.splice(index, 1);
    this.cabecera.glosa = this.formatGlosa;
  }

  getCliente(ci: string) {
    this.recaudacionService.getCliente(ci);
  }
}
</script>

<style scoped>
tr:nth-child(even) {
  background-color: #FAFAFA;
}

.simple-table {
  border: 1px solid #DDDDDD;
}

@media screen {
  #myElement {
    display: none;
  }
}
</style>
